// AI Generated Component
import { Component, Input } from '@angular/core';

@Component({
    selector: 'page-details-section-dashboard-blocks-overview',
    standalone: false,
    template: `
        <div class="page-details-dashboard-overview d-flex">
            <div class="pr-3">
                <span class="fa-stack fa-2x" aria-hidden="true">
                    <span class="fas fa-circle fa-stack-2x text-link"></span>
                    <span class="fa-stack-1x fa-inverse" [ngClass]="icon"></span>
                </span>
            </div>
            <div>
                <p class="text-grey font-size-0-9 title mb-0 pb-0 pr-1 inline-block">
                    {{ infoHeading }}
                </p>
                <span class="inline-block fas fa-info-circle"
                      *ngIf="monTooltipText"
                      aria-hidden="true"
                      [ngbTooltip]="monTooltipText"
                      triggers="focus hover">
                </span>
                <div class="content block">
                    <ng-content></ng-content>
                </div>
            </div>
        </div>
    `,
})
export class PageDetailsSectionDashboardBlocksOverviewComponent {
    @Input() infoHeading!: string;
    @Input() icon!: string;
    @Input() monTooltipText?: string;
}
